import React, { useRef, useState } from "react";
import { toast } from "react-toastify";

const EditSPModal = ({
  isVisible,
  onCancel,
  onConfirm,
  product,
  deviceType,
  i18n,
  t,
  AlphaNumericKeyboardModal,
}) => {
  const inputRef = useRef(null);
  const [tempSP, setTempSP] = useState(product?.sale_price);
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric");

  if (!isVisible) return null;

  console.log('product?.sale_price==>',product?.sale_price);
  
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-30 backdrop-blur-md drop-shadow-sm">
      {/* Overlay */}
      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>

      {/* Modal */}
      <section
        className={`flex flex-col px-12 py-12 text-lg font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 z-50 ${
          deviceType === "tablet" ? "fixed left-20" : "relative"
        }`}
        style={{ width: "500px" }}
      >
        {/* Header */}
        <header className="flex gap-5 text-2xl max-md:flex-wrap max-md:max-w-full">
          <h1 className="flex-auto my-auto">{t("Edit Selling Price")}</h1>

          <button
            type="button"
            onClick={onCancel}
            className="absolute top-4 right-3 text-zinc-800 bg-transparent"
          >
            ✕
          </button>
        </header>

        {/* Input */}
        <div
          className={`flex flex-row items-center ${
            i18n.language === "ar" ? "justify-end" : "justify-start"
          }`}
        >
          <div className="relative w-full">
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              maxLength={10}
              value={tempSP}
              readOnly={deviceType === "tablet"}
              placeholder={t("Enter price")}
              onFocus={() => {
                if (deviceType === "tablet") {
                  setKeyboardMode("numeric");
                  setShowKeyboard(true);
                }
              }}
           onChange={(e) => {
  let value = e.target.value;

  // Allow only numbers and decimal
  if (!/^\d*\.?\d*$/.test(value)) return;

  // Restrict to 2 digits after decimal
  if (value.includes(".")) {
    const [int, dec] = value.split(".");
    if (dec.length > 2) return;
  }

  // Restrict max value to 99999
  if (Number(value) > 99999) return;

  setTempSP(value);
}}
              className="p-3 mt-4 rounded-xl border border-neutral-400 text-black w-full focus:outline-none"
            />

            {/* Currency */}
            <span
              className={`absolute ${
                i18n.language === "ar" ? "left-3" : "right-3"
              } top-10 transform -translate-y-1/2 text-md text-black`}
            >
              EGP
            </span>
          </div>
          
        </div>
        {product?.actual_price && 
        <div className="text-base text-gray-600 mt-1 ms-2">
            {t("Actual Sales Price: ")} EGP {product?.actual_price?.toFixed(2)}
          </div>
        }

        {/* Buttons */}
        <div className="flex justify-between gap-5">
          <button
            onClick={onCancel}
            className="px-12 py-3.5 mt-10 text-xl text-[#7EC242] rounded-lg border-2 border-[#7EC242] bg-white"
          >
            {t("Cancel")}
          </button>

          <button
            onClick={() => {
              if(tempSP < (product?.actual_price ? product?.actual_price : product?.sale_price)){
                toast.error(t('Price must be greater than the sale price.'))
              }else{
  onConfirm(tempSP)
              }
            }}
            className="px-12 py-3.5 mt-10 text-xl text-white bg-[#7EC242] rounded-lg"
          >
            {t("Confirm")}
          </button>
        </div>
      </section>

      {/* Tablet Keyboard */}
      {deviceType === "tablet" && showKeyboard && (
        <AlphaNumericKeyboardModal
          mode={keyboardMode}
          width="42%"
          maxWidth="42%"
          maxHeight="54%"
          onClose={() => setShowKeyboard(false)}
          onKeyPress={(key) => {
            if (key === "DEL") {
              setTempSP((prev) => prev.slice(0, -1));
            } else {
              const newVal = tempSP + key;
              if (newVal.match(/^\d*\.?\d{0,2}$/)) {
                setTempSP(newVal);
              }
            }
          }}
        />
      )}
    </div>
  );
};

export default EditSPModal;